import React from 'react';

const FlowChartPromptWindows = ({
  promptWindows,
  setPromptWindows,
  draggingWindowId,
  setDraggingWindowId,
  setDragOffset,
  setResizingWindowId,
  setResizeStart,
  setResizeDirection,
  closePromptWindow,
  toggleMinimizeWindow,
  onSavePromptWindow,
  onChangePrompt,
}) => {
  return (
    <>
      {promptWindows.map((win) => {
        const zIndex = 100004 + promptWindows.length - promptWindows.findIndex((w) => w.id === win.id);
        const winWidth = win.isMinimized ? 420 : win.width || 620;
        const winHeight = win.isMinimized ? 40 : win.height || 360;

        return (
          <div
            key={win.id}
            style={{
              position: 'fixed',
              left: Math.max(0, Math.min(win.position.x, window.innerWidth - winWidth)),
              top: Math.max(0, Math.min(win.position.y, window.innerHeight - winHeight)),
              width: winWidth,
              height: winHeight,
              background: '#2d2d2d',
              borderRadius: 8,
              border: '2px solid #3e3e42',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
              display: 'flex',
              flexDirection: 'column',
              zIndex: zIndex,
              overflow: 'hidden',
              userSelect: 'none',
            }}
            onClick={() => {
              setPromptWindows((prev) => {
                const filtered = prev.filter((w) => w.id !== win.id);
                return [...filtered, win];
              });
            }}
          >
            {/* Header - Draggable */}
            <div
              onMouseDown={(e) => {
                const rect = e.currentTarget.closest('div').getBoundingClientRect();
                setDragOffset({
                  x: e.clientX - rect.left,
                  y: e.clientY - rect.top,
                });
                setDraggingWindowId(win.id);
              }}
              style={{
                background: '#1e1e1e',
                borderBottom: '1px solid #3e3e42',
                padding: '8px 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: draggingWindowId === win.id ? 'grabbing' : 'grab',
                flexShrink: 0,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
                <h3
                  style={{
                    color: '#cccccc',
                    margin: 0,
                    fontSize: 14,
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  title={`${win.stepLabel || win.shapeId} (${win.shapeId})`}
                >
                  🧠 Prompt · {win.stepLabel || win.shapeId}
                </h3>
                <span style={{ color: '#777', fontSize: 11, whiteSpace: 'nowrap' }}>{win.shapeId}</span>
                {win.saveStatus && (
                  <span
                    style={{
                      fontSize: 11,
                      padding: '2px 6px',
                      borderRadius: 4,
                      color: win.saveStatus.state === 'error' ? '#ff6b6b' : '#a7f3d0',
                      background: win.saveStatus.state === 'error' ? '#3a1f1f' : '#1f3a2a',
                      border: `1px solid ${win.saveStatus.state === 'error' ? '#5a2a2a' : '#2a5a3a'}`,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {win.saveStatus.message}
                  </span>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onSavePromptWindow(win.id);
                  }}
                  style={{
                    background: '#0e639c',
                    border: 'none',
                    color: '#ffffff',
                    padding: '4px 10px',
                    borderRadius: 4,
                    fontSize: 11,
                    cursor: 'pointer',
                    fontWeight: 600,
                  }}
                  title="Workflow içine yaz (Kaydet butonuyla server'a gider)"
                >
                  💾 Uygula
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleMinimizeWindow(win.id);
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#888',
                    fontSize: 16,
                    cursor: 'pointer',
                    padding: '4px 8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  title={win.isMinimized ? 'Büyüt' : 'Küçült'}
                >
                  {win.isMinimized ? '□' : '−'}
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    closePromptWindow(win.id);
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#888',
                    fontSize: 18,
                    cursor: 'pointer',
                    padding: '4px 8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  title="Kapat"
                >
                  ×
                </button>
              </div>
            </div>

            {/* Content */}
            {!win.isMinimized && (
              <div
                style={{
                  flex: 1,
                  overflow: 'hidden',
                  background: '#1e1e1e',
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 0,
                  padding: 10,
                  gap: 8,
                }}
              >
                <div style={{ color: '#9aa0a6', fontSize: 11 }}>
                  Not: Bu prompt, üstteki “Kaydet” butonuna basınca step ile birlikte server'a gönderilir.
                </div>
                <textarea
                  data-ignore-global-hotkeys="true"
                  value={win.prompt || ''}
                  onChange={(e) => onChangePrompt(win.id, e.target.value)}
                  placeholder="Bu step için AI talimatını yaz..."
                  style={{
                    width: '100%',
                    height: '100%',
                    flex: 1,
                    resize: 'none',
                    background: '#0d1117',
                    border: '1px solid #2a2a2a',
                    borderRadius: 8,
                    padding: 10,
                    color: '#c9d1d9',
                    fontSize: 12,
                    lineHeight: 1.4,
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                    outline: 'none',
                    userSelect: 'text',
                  }}
                />
              </div>
            )}

            {/* Resize Handles - 4 köşe */}
            {!win.isMinimized && (
              <>
                <div
                  onMouseDown={(e) => {
                    e.stopPropagation();
                    setResizingWindowId(win.id);
                    setResizeStart({
                      x: e.clientX,
                      y: e.clientY,
                      width: win.width || 620,
                      height: win.height || 360,
                      startX: win.position.x,
                      startY: win.position.y,
                    });
                    setResizeDirection('nw');
                  }}
                  style={{
                    position: 'absolute',
                    top: -2,
                    left: -2,
                    width: 12,
                    height: 12,
                    cursor: 'nw-resize',
                    zIndex: zIndex + 1,
                    background: 'rgba(6, 182, 212, 0.25)',
                    border: '1px solid rgba(6, 182, 212, 0.55)',
                    borderRadius: '2px',
                  }}
                />
                <div
                  onMouseDown={(e) => {
                    e.stopPropagation();
                    setResizingWindowId(win.id);
                    setResizeStart({
                      x: e.clientX,
                      y: e.clientY,
                      width: win.width || 620,
                      height: win.height || 360,
                      startX: win.position.x,
                      startY: win.position.y,
                    });
                    setResizeDirection('ne');
                  }}
                  style={{
                    position: 'absolute',
                    top: -2,
                    right: -2,
                    width: 12,
                    height: 12,
                    cursor: 'ne-resize',
                    zIndex: zIndex + 1,
                    background: 'rgba(6, 182, 212, 0.25)',
                    border: '1px solid rgba(6, 182, 212, 0.55)',
                    borderRadius: '2px',
                  }}
                />
                <div
                  onMouseDown={(e) => {
                    e.stopPropagation();
                    setResizingWindowId(win.id);
                    setResizeStart({
                      x: e.clientX,
                      y: e.clientY,
                      width: win.width || 620,
                      height: win.height || 360,
                      startX: win.position.x,
                      startY: win.position.y,
                    });
                    setResizeDirection('sw');
                  }}
                  style={{
                    position: 'absolute',
                    bottom: -2,
                    left: -2,
                    width: 12,
                    height: 12,
                    cursor: 'sw-resize',
                    zIndex: zIndex + 1,
                    background: 'rgba(6, 182, 212, 0.25)',
                    border: '1px solid rgba(6, 182, 212, 0.55)',
                    borderRadius: '2px',
                  }}
                />
                <div
                  onMouseDown={(e) => {
                    e.stopPropagation();
                    setResizingWindowId(win.id);
                    setResizeStart({
                      x: e.clientX,
                      y: e.clientY,
                      width: win.width || 620,
                      height: win.height || 360,
                      startX: win.position.x,
                      startY: win.position.y,
                    });
                    setResizeDirection('se');
                  }}
                  style={{
                    position: 'absolute',
                    bottom: -2,
                    right: -2,
                    width: 12,
                    height: 12,
                    cursor: 'se-resize',
                    zIndex: zIndex + 1,
                    background: 'rgba(6, 182, 212, 0.25)',
                    border: '1px solid rgba(6, 182, 212, 0.55)',
                    borderRadius: '2px',
                  }}
                />
              </>
            )}
          </div>
        );
      })}
    </>
  );
};

export default FlowChartPromptWindows;

